"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTelHref = getTelHref;

function getTelHref(tel) {
  var regex = /^\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/g;

  if (!tel.match(regex)) {
    throw "Telephone number ".concat(tel, " is not formatted correctly. It must be in one of the following formats:\nxxx-xxx-xxxx\n(xxx) xxx xxxx\n(xxx)-xxx-xxxx\nxxxxxxxxxx\n        ");
  }

  var href = "tel:+1" + tel.replace(/\D/g, '');
  return href;
}